import React from "react";

import classes from "./Button.module.css";

const Button = (props) => {
  return (
    // <button className={classes.button} type={props.type || "button"}>
    //   {props.children}
    // </button>
    <input
      type={props.type || "submit"}
      value={props.value || "Submit"}
      className={props.buttonStyle || classes.button}
      onClick={props.onClick}
      disabled={props.isDisabled}
    />
  );
};

export default Button;
